import { Avatar, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { SideBurgerHome } from 'Images';
import { onEnterOrEscapeKeyDown } from 'Utils/accessibilityOnKeyDown';
import { getIsLawyer, getIsLawyerAndUser } from 'Utils/lawyers';
import { useNavigate } from 'react-router-dom';
import { useIsLawyerArea } from 'Hooks/useIsLawyerArea';

interface IHomePageTab {
  closeAccordionTabs: Function;
}
export const HomePageTab = ({ closeAccordionTabs }: IHomePageTab) => {
  const navigate = useNavigate();

  const isLawyerArea = useIsLawyerArea();

  const isLawyer = getIsLawyerAndUser() ? isLawyerArea : getIsLawyer();

  return (
    <Stack
      direction='row'
      onClick={() => {
        closeAccordionTabs();
        window.scrollTo({ top: 0, behavior: 'smooth' });
        navigate(isLawyer ? '/lawyers-lobby' : '/');
      }}
      onKeyDown={onEnterOrEscapeKeyDown}
      tabIndex={0}
      component='li'
      role='link'
      sx={{
        alignItems: 'center',
        gap: '16px',
        height: '64px',
        pr: '24px',

        '&:hover , &:focus': {
          cursor: 'pointer',
          bgcolor: 'primary.shade_500',
          outline: 'none',
        },
      }}
    >
      <Avatar
        alt={''}
        src={SideBurgerHome}
        sx={{ width: '24px', height: '24px' }}
      />
      <Typography variant={'body4'}>
        {isLawyer
          ? Dictionary[DICTIONARY.General].sidebar.lawyerHome
          : Dictionary[DICTIONARY.General].sidebar.home}
      </Typography>
    </Stack>
  );
};
